import {Suspense} from 'react';
import {createRootRouteWithContext, Outlet} from '@tanstack/react-router';
import {TanStackRouterDevtools} from '@tanstack/react-router-devtools';
import NotFoundPage from '@/anonymous/views/error/NotFoundPage';
import AppLoading from '@/shared/components/ui/AppLoading';
import {AppRouterContext} from '@/shared/routing';

function RootComponent() {
  return (
    <Suspense fallback={<AppLoading />}>
      <Outlet />
      {import.meta.env.VITE_LEGIT_HEALTH_APP_KEY_PREFIX !== 'LEGIT_HEALTH_APP_TEST' && (
        <TanStackRouterDevtools initialIsOpen={false} />
      )}
    </Suspense>
  );
}

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: RootComponent,
  notFoundComponent: () => <NotFoundPage />
});
